import { Skeleton } from '@/components/ui/Skeleton.tsx';
import {
  InfoCard,
  InfoCardBody,
  InfoCardRow,
} from '@/components/ui/InfoCard.tsx';

/** Szkielet karty szkicu: nagłówek, trzy wiersze i trzy przyciski wyjścia. */
const DraftCardSkeleton = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <InfoCard tone="accent" {...props}>
    <div className="flex items-center gap-2.5 border-b border-accent-border px-5 py-4">
      <Skeleton className="size-2 rounded-full" />
      <Skeleton className="h-3.5 w-36" />
    </div>

    <InfoCardBody className="pb-[18px] pt-4">
      {['pozycje', 'utworzyl', 'ostatni-zapis'].map((row) => (
        <InfoCardRow key={row} label={<Skeleton className="h-4 w-24" />}>
          <Skeleton className="h-4 w-28" />
        </InfoCardRow>
      ))}
    </InfoCardBody>

    <div className="flex flex-col gap-2.5 px-5 pb-[18px]">
      <Skeleton className="h-11 w-full rounded-md" />
      <Skeleton className="h-11 w-full rounded-md" />
      <Skeleton className="h-8 w-full rounded-md" />
    </div>
  </InfoCard>
);

export default DraftCardSkeleton;
